export function mapQuote (quote) {
  const arr = quote.split(',')
  return {
    name: arr[0],
    open: arr[1],
    prevClose: arr[2],
    lastTrade: Number.parseFloat(arr[3]).toFixed(2),
    highest: arr[4],
    lowest: arr[5],
    bid: arr[6],
    ask: arr[7],
    volume: arr[4],
    turnover: arr[5],
    change: arr[3] - arr[2],
    chg: (arr[3] - arr[2]) / arr[2],
    isSuspension: arr[arr.length - 1] === '03',
    exit_market: arr[arr.length - 1] === '-3',
    no_in_market: arr[arr.length - 1] === '-2',
    no_data: arr[arr.length - 1] === '-1'
  }
}

export function mapQuotes (quote) {
  const arr = quote.split(',')
  return {
    Condition: arr[arr.length - 4] === '3'
  }
}

export function mapQuoteSimple (quote) {
  const arr = quote.split(',')
  return {
    name: arr[0],
    lastTrade: Number.parseFloat(arr[1]).toFixed(2),
    change: arr[2],
    chg: arr[3] / 100,
    volume: arr[4],
    turnover: arr[5]
  }
}

export function mapStarStock (stock) {
  return {
    name: stock.stock,
    hs300: Number.parseFloat(stock.hs300) / 100,
    rate: Number.parseFloat(stock.margin) / 100,
    market: stock.market,
    comment: stock.result,
    symbol: stock.symbol,
    theme: stock.concept,
    date: stock.date
  }
}

export function mapHotestStock (stock) {
  return {
    name: stock.stock,
    symbol: stock.symbol
  }
}

export function mapSearchResult (stock) {
  const fields = stock.split(',')
  return {
    symbol: fields[3],
    type: fields[1],
    name: fields[4],
    abbr: fields[5]
  }
}



// WEBPACK FOOTER //
// ./src/plugins/stock/map.js